import React from 'react';

import LoadingIndicator from '@dashboard/components/loading/LoadingIndicator';
import { FWaypointTemplateFragment } from '@dashboard/generated/wp/platform';
import { Box } from '@mui/material';

import ScaledBox from '../ScaledBox';

import ThumbnailWaypointDocument from './ThumbnailWaypointDocument';
import useTemplateConfiguration from './useTemplateConfiguration';

type Props = {
  template: FWaypointTemplateFragment;
};
export default function TemplateThumbnailPreview({ template }: Props) {
  const { data, loading } = useTemplateConfiguration(template);

  if (loading) {
    return (
      <Box sx={{ height: '100%', overflow: 'hidden', position: 'relative' }}>
        <LoadingIndicator />
      </Box>
    );
  }

  return (
    <Box sx={{ height: '100%', overflow: 'hidden', position: 'relative' }}>
      <ScaledBox>
        <ThumbnailWaypointDocument configuration={data} variables={template.defaultPreviewVariables} />
      </ScaledBox>
      <Box sx={{ top: 0, bottom: 0, left: 0, right: 0, position: 'absolute' }} />
    </Box>
  );
}
